export default class BotCheckerForm {
    constructor() {
        this.documentLoadedTime = 0;
        this.recaptchaToken = null;
        this.loadGRecaptchaToken();

        const timerCrForm = setInterval(() => {
            if (document.readyState !== 'loading') {
                this.documentLoadedTime = Date.now();

                clearInterval(timerCrForm)
            }
        }, 100);
    }

    getTimeFromStart() {
        return Math.floor((Date.now() - this.documentLoadedTime) / 1000);
    }

    loadGRecaptchaToken() {
        if (typeof grecaptcha === "undefined" || typeof grecaptcha.enterprise === "undefined") {
            this.recaptchaToken = null;
            return;
        }

        const gRecaptchaSiteToken = document.querySelector("meta[name='grecaptcha-site-key']").content
        grecaptcha.enterprise.ready(async () => {
            grecaptcha.enterprise.execute(gRecaptchaSiteToken, {action: 'submit_action'}).then((token) => {
                this.recaptchaToken = token;
            });
        });
    }

    getGRecaptchaToken() {
        return this.recaptchaToken;
    }

    setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
}
